import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"

export default function SalesOrderTypeSelect({ value, onChange }) {
  return (
    <FormControl size="small" sx={{ minWidth: 160 }}>
      <InputLabel id="sales-order-type-label">Order Type</InputLabel>
      <Select
        labelId="sales-order-type-label"
        value={value}
        label="Order Type"
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="pos">POS</MenuItem>
        <MenuItem value="website">Website</MenuItem>
      </Select>
    </FormControl>
  )
}
